<div class="progress-container position-relative">
  <div class="start-ellipse"></div>
  <div class="number-position translate-middle">
    <p class="mb-0 text-completed">{{ completed }}</p>
    <p class="mb-0 text-totals">/{{ totals }}</p>
  </div>
  <div
    class="progress-bar position-absolute"
    [style]="{ width: (completed / totals) * 96 + '%' }"></div>
  <img
    [src]="
      completed == totals
        ? 'assets/images/camillo/coccarda-completed.svg'
        : 'assets/images/camillo/coccarda.svg'
    "
    alt=""
    class="img-coin"
    [style]="{ opacity: completed == totals ? '1' : '0.5' }" />
</div>
